import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { storeCreator, TPreloadedState } from './state/store';
import { Provider } from 'react-redux';
import isPropValid from '@emotion/is-prop-valid';
import { StyleSheetManager } from 'styled-components';

// prevent prototype pollution
[
  Object,
  Object.prototype,
  Function,
  // Unable to seal as redux-toolkit does not work with sealed functions: Function.prototype,
  Array,
  Array.prototype,
  String,
  String.prototype,
  Number,
  Number.prototype,
  Boolean,
  Boolean.prototype,
].forEach(Object.freeze);

export type { TPreloadedState };

export interface IWrapAppProps {
  preloadedState?: TPreloadedState;
  children: React.ReactNode;
}

let store: ReturnType<typeof storeCreator> | null = null;

export const WrapApp: React.FC<IWrapAppProps> = ({ children, preloadedState }) => {
  if (!store) {
    store = storeCreator(preloadedState);
  }
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Provider store={store}>{children}</Provider>
    </StyleSheetManager>
  );
};

// @ts-ignore
const root = createRoot(document.getElementById('root'));
root.render(
  <WrapApp>
    <App />
  </WrapApp>,
);

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: any) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}
